import type { PluginDefinition } from './types';
import { loyaltyPlugin } from './loyalty';
import { portalClientePlugin } from './portal-cliente';
import { sacolinhasPlugin } from './sacolinhas';

export const PLUGIN_DEFINITIONS: PluginDefinition[] = [
  loyaltyPlugin as PluginDefinition,
  portalClientePlugin as PluginDefinition,
  sacolinhasPlugin as PluginDefinition,
];

export const getPluginDefinition = (slug: string): PluginDefinition | undefined =>
  PLUGIN_DEFINITIONS.find((p) => p.slug === slug);
